// Example:
// export * from "../modules/Person/default/index.js";
export * from "../parts/header.js";
export * from "../modules/button/lightbox/index.js";
export * from "../modules/gallery/scroller/index.js";